<div *ngIf="errors && errors.length > 0" class="alert alert-danger" role="alert">
    <ul>
      <li *ngFor="let err of errors">{{err}}</li>
    </ul>
  </div>